import React from 'react';
import {useTheme} from "../../../../../ThemeContext";

import styles from './Panel.module.scss';

type Props = {
  id?: string;
  children?: React.ReactNode;
};

const Panel: React.FC<Props> = ({ children, ...rest }) => {
  const {universalStyles}=useTheme()
  return (
    <div className={styles.panel} {...rest} style={universalStyles.modalBackgroundColors}>
      {children}
    </div>
  );
};

export default Panel;
